module.exports = __webpack_public_path__ + "static/tooltip1_9-7137a7d5b5aa05db9de7f0362555e6d9.png";